export default class BannerModel {
  public bannerId: string = "";
  public titulo: string = "";
  public imagem: string = "";
  public corFundo: string = "";
  public link: string = "";

  public static toModel(item: any): BannerModel {
    return {
      bannerId: item.id,
      titulo: item.title,
      imagem: item.cover,
      corFundo: item.cor_fundo,
      link: item.link,
    } as BannerModel;
  }
}